import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';

import UpcomingPublicationList from './list/upcomingPublicationList';
import UpcomingPublicationListFilters from './filters/upcomingPublicationListFilters';
import UpcomingPublicationListSummary from './list/upcomingPublicationListSummary';
import PublicationSearch from '../common/sponsorships/filters/publicationSearch';
import { getUpcomingPublications, getUpcomingPublicationFilters, exportUpcomingPublications } from './upcomingPublication.actions';
import { getDefaultRequestBuilder, availableUpcomingPublicationStatuses } from '../common/sponsorships/filters/filterHelper';
import { useAuth0, getSelectedTenantId } from '../app/auth';
import LoadingIndicator from '../common/loadingIndicator';

const UpcomingPublicationIndexComponent = ({isExporting, onComponentMount, onExport}) => {

  const [dialogVisible, setDialogVisible] = useState(false);
  const { getTokenSilently, user } = useAuth0();

  useEffect(() => {    
    const notifyComponentMount = async() => {
      const token = await getTokenSilently();
      const builder = getDefaultRequestBuilder(true);
      onComponentMount({
        pageNumber: 1,
        pageSize: 150,
        sortByField: 'date',
        sortByDirection: 'desc',
        filterQueryString: builder.getQueryString()
      }, token, getSelectedTenantId(user, token));
    };
    notifyComponentMount();
  });

  const toggleDialog = () => {
    setDialogVisible(!dialogVisible);
  };

  if(isExporting) {
    return <LoadingIndicator/>;
  }

  return (
      <div id="publications-container">
        <div className="title-container">
        <h1>Upcoming Publication Tracker</h1>
        </div>
        <div className="publication-list-container">
          <div className="filters">
            <UpcomingPublicationListFilters />
          </div>
          <div className="list">
            <PublicationSearch />
            <UpcomingPublicationListSummary />
            <UpcomingPublicationList />
          </div>
        </div>

        {dialogVisible && 
          <Dialog title="Exporting data" onClose={toggleDialog}>
            <p style={{ margin: "25px", textAlign: "center" }}>
              You will receive a Slack notification with a link to download the file. <br/>
              It will take around 5 minutes.
            </p>
            <DialogActionsBar>
                <button className="k-button k-primary" onClick={toggleDialog}>OK</button>
            </DialogActionsBar>
          </Dialog>
        }
      </div>
    );
};

function mapDispatchToProps(dispatch) {
  const props = {
    onExport: (exportFields, token, tenantId) => dispatch(exportUpcomingPublications(exportFields, token, tenantId)),
    onComponentMount: (options, token, tenantId) => {
      dispatch(getUpcomingPublicationFilters(availableUpcomingPublicationStatuses, token, tenantId));
      dispatch(getUpcomingPublications(options, token, tenantId));
    }
  };
  return props;
}

const UpcomingPublicationIndex = connect(null, mapDispatchToProps)(UpcomingPublicationIndexComponent);
export default UpcomingPublicationIndex;